import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import './App.css';
import Services from './pages/Services';
import BookService from './pages/BookService';
import SignUp from './pages/SignUp';
import SignIn from './pages/SignIn';
import ForgotPassword from './pages/ForgotPassword';
import Products from './pages/Products';
import Store from './pages/Store';
import Favorites from './pages/Favorites';
import MyProfile from './pages/MyProfile';
import ProductView from './pages/ProductView';
import MyOrders from './pages/MyOrders';
import PreviewRequests from './pages/PreviewRequests';
import MyCart from './pages/MyCart';
import Checkout from './pages/Checkout';
import ChatApp from './pages/ChatApp';
import AllOrders from './pages/AllOrders';
import AllPreviewRequests from './pages/AllPreviewRequests';
import PaymentDone from './pages/PaymentDone';
import CompDetails from './pages/CompDetails';
import ChatAppWithAdmin from './pages/ChatAppWithAdmin';
import AllNotifications from './pages/AllNotifications';
import SignUpOtp from './pages/SignUpOtp';
import AllOrdersUnderGuarantee from './pages/AllOrdersUnderGuarantee';
import SamplePage from './pages/SamplePage';
import Terms_conditions from './pages/Terms_conditions';
import FormApp from './pages/FormApp';
import Politecs from './pages/Politecs';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:id" element={<BookService />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/forgotPassword" element={<ForgotPassword />} />
          <Route path="/products" element={<Products />} />
          <Route path="/store" element={<Store />} />
          {/* <Route path="/products" element={<SamplePage />} /> */}
          {/* <Route path="/store" element={<SamplePage />} /> */}
          <Route path="/favorites" element={<Favorites />} />
          {/* <Route path="/favorites" element={<SamplePage />} /> */}
          <Route path="/myprofile" element={<MyProfile />} />
          {/* <Route path="/productview/:id" element={<ProductView />} /> */}
          <Route path="/productview/:id" element={<SamplePage />} />
          <Route path="/myorders" element={<MyOrders />} />
          <Route path="/previewrequests" element={<PreviewRequests />} />
          <Route path="/cart" element={<MyCart />} />
          {/* <Route path="/cart" element={<SamplePage />} /> */}
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/chat/:idOrder" element={<ChatApp />} />
          <Route path="/allOrders" element={<AllOrders />} />
          <Route path="/allpreviewrequests" element={<AllPreviewRequests />} />
          <Route path="/paymentcomplete" element={<PaymentDone />} />
          <Route path="/compdetails/:admin_id" element={<CompDetails />} />
          <Route path="/chatadmin/:admin_id" element={<ChatAppWithAdmin />} />
          <Route path="/notifications" element={<AllNotifications />} />
          <Route path="/signupotp" element={<SignUpOtp />} />
          <Route path="/allordersunderguarantee" element={<AllOrdersUnderGuarantee />} />
          <Route path="/samplepage" element={<SamplePage />} />
          <Route path="/terms_conditions" element={<Terms_conditions />} />
          <Route path="/formapp" element={<FormApp />} />

          <Route path="/politecs" element={<Politecs />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
